export const APP_COLORS = {
  PRIMARY: "#01496e",
  PRIMARY_LIGHT: "#96c1d6",
  PRIMARY_LIGHT_2: "#E3F1F6",
  SECONDARY: "#F0A801",
  ACCENT: "#04d443",
  TEXT: "#1b323d",
  LIGHT: "#ffffff",
  LIGHT_2: "#fbfcfe",
  LIGHT_3: "#d5ebdc",
  LIGHT_4: "#e1e1e1",
  DARK: "#000000",
  PINK: "#FF5837",
  PINK_LIGHT: "#fc9b88",
  TEAL: "#03c588",
  TEAL_LIGHT: "#96eda1",
  TEAL_LIGHTER: "#EBE974",
  BlUE_GRAY: "#51566a",
  CHART_PRIMARY: "#01496e",
  CHART_PRIMARY_LIGHT: "#96c1d6",
  CHART_ESTIMATED: "rgba(74, 79, 102, 0.12)",
  BLUE_FB: "#0866FF",
  DARK_GREEN: "#2E9265",
  SUCCESS: "#009688",
  INFO: "#1E88E5",
  ERROR: "#b71c1c",
  RED_1: "#FB1C2C",
  GREEN_1: "#1BCB11",
  ORANGE_1: "#FDAA10",
  TEXT_MUTED: "#9C9FAC",
  RED_2: "#FD5285",
  GRAY_2: "#ECECEC",
  STAR_FILL: "#fbbc04",
  APPLE_DARK: "#1d1d1f",
  WARNING: "#f2ae01"
};
